<div class="d-flex align-items-center copy-note-cell" *ngIf="note">
    <a href="javascript:void(0);" class="text-primary d-flex mr-1" tooltipPosition="top" pTooltip="Copy to clipboard"
        (click)="copyNote($event)">
        <span class="material-symbols-outlined">
            content_copy
        </span>
    </a>
    <span class="copy-note-text" (click)="notePanel.toggle($event)">{{ note }}</span>
    <p-overlayPanel #notePanel styleClass="checkcall-note-overlay" appendTo="body" [showCloseIcon]="true"
        [dismissable]="true">
        <ng-template pTemplate="content">
            <div class="copy-note-content">
                {{ note }}
            </div>
        </ng-template>
    </p-overlayPanel>
</div>
